import { GetStartedContent, OnboardingStep, StepMedia, WidgetUiLabels } from './model';
// Контент шагов и UI-подписи (англ. по умолчанию). Структура готова к будущим steps.<lang>.json.
// Если возникнут проблемы с resolveJsonModule — фолбэк: вынести содержимое в .ts-константу.
import stepsContent from './content/steps.en.json';
// Медиа шагов туториала: по одному ролику на шаг. Маппинг шаг → медиа задаётся ниже,
// lazy-load уже на месте.
import step1Media from './media/step-1.mp4';
import step2Media from './media/step-2.mp4';
import step3Media from './media/step-3.mp4';
import step4Media from './media/step-4.mp4';
import step5Media from './media/step-5.mp4';

const content = stepsContent as GetStartedContent;

/** UI-подписи виджета (заголовок, навигация, шаблон прогресса и т.д.) */
export const UI_LABELS: WidgetUiLabels = content.ui;

const STEP_MEDIA: Record<string, StepMedia | undefined> = {
  'sandbox-folder': { type: 'video', src: step1Media },
  'upload-files': { type: 'video', src: step2Media },
  'search-modes': { type: 'video', src: step3Media },
  sidebar: { type: 'video', src: step4Media },
  'magic-studio': { type: 'video', src: step5Media },
};

/** Полный конфиг шагов: контент из JSON + медиа, без фильтрации по фичефлагам.
 *  Видимость шага про Magic Studio теперь зависит от рантайм-настройки инстанса
 *  (magic_studio_enabled из GET /api/asset-lab/settings, MYUA-16447), поэтому
 *  фильтр вынесен в onboardingSteps() — константу модульного уровня фильтровать
 *  нечем, стор на момент её вычисления ещё не готов. */
export const ALL_ONBOARDING_STEPS: OnboardingStep[] = content.steps.map((step) => ({
  ...step,
  media: STEP_MEDIA[step.id],
}));

/** Шаги, которые реально показываем пользователю: шаг про Magic Studio скрыт,
 *  когда фича выключена на инстансе (см. app/selectors.getMagicStudioEnabled). */
export function onboardingSteps(magicStudioEnabled: boolean): OnboardingStep[] {
  return ALL_ONBOARDING_STEPS.filter((step) => magicStudioEnabled || step.id !== 'magic-studio');
}
